
import React, { useState, ChangeEvent } from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import ResponsiveEmbed from 'react-bootstrap/ResponsiveEmbed';
import $ from 'jquery';

import { renderContent, ArticleInterface } from './page_data'; 
import FeatureImage from './feature-image';

import CKEditor from 'ckeditor4-react';

import { 
  CKEditorEvent,
  updateArticleHandler,
  MODAL_BODY_ID,
  MODAL_ID,
  UPLOADER_ADDRESS,
} from '../globals';

const EMBED_URL_EXAMPLE = 'https://wpexplorer-themes.com/total/docs/get-embed-urllink-youtube-video/';
const ARTICLE_TITLE_INPUT_ID = 'article__heading-ctrl';
const VIDEO_URL_INPUT_ID = 'article__video-ctrl--url'

type ArticleProps = {
  article: ArticleInterface,
  editMode: boolean,
  onVideoUrlChange: updateArticleHandler,
  onBodyContentChange: updateArticleHandler,
  onFeatureImageChange: updateArticleHandler,
  onTitleChange: updateArticleHandler,
  toggleFullWidth: updateArticleHandler<boolean>,
  toggleImageDisplay: updateArticleHandler<boolean>,
}

const ArticleView: React.FunctionComponent<ArticleProps> = ({
  article,
  editMode,
  onVideoUrlChange,
  onBodyContentChange,
  onFeatureImageChange,
  onTitleChange,
  toggleFullWidth,
  toggleImageDisplay,
}) => {
  const [showModal, setShowModal] = useState(false);

  const onShowModal = () => {
    setShowModal(true);
  }

  const onHideModal = () => {
    setShowModal(false);
  }

  const { 
    id, 
    title, 
    content, 
    videoUrl, 
    imageSrc, 
    fullWidthImage,
    displayImage,
    
  } = article;
  return (
    <>
      <Col
        xs={{span: 12}}
        className="article"
      >
        <Row>
          <Col
            xs={{span: 12}}
            as="section"
          >
            <h1 className="article__heading">
              {editMode
                ? <input
                    id={ARTICLE_TITLE_INPUT_ID}
                    className="editable-input article__heading-ctrl"
                    type='text'
                    value={title}
                    onChange={(e: ChangeEvent<HTMLInputElement>) => {
                      const newContent: string = e.target.value;
                      onTitleChange(newContent);
                    }}
                  />
                : title
              }
            </h1>
            <FeatureImage
              imageSrc={imageSrc}
              editMode={editMode}
              onFeatureImageChange={onFeatureImageChange}
              onToggleUploader={onShowModal}
              fullWidth={fullWidthImage}
              displayImage={displayImage}
              onToggleFullWidth={(fullWidth: boolean)=>toggleFullWidth(fullWidth, id)}
              onToggleImageDisplay={(display: boolean)=>toggleImageDisplay(display, id)}
            />
            <div className="article__body">
              {editMode
                ? <CKEditor
                    data={content}
                    onBeforeLoad={( CKEDITOR: any ) => ( CKEDITOR.disableAutoInline = true ) }
                    onBlur={(e: CKEditorEvent )=>{
                      const newContent: string = e.editor.getData();
                      onBodyContentChange(newContent);
                    }}
                    type="classic"
                  />
                : renderContent(content)
              }
            </div>
          </Col>
          <Col
            xs={{span: 12}}
          >
            <div style={{ width: '100%', height: 'auto' }}>
              <ResponsiveEmbed 
                aspectRatio="16by9"
                style={{display: (videoUrl ? 'block' : 'none')}}
              >
                <iframe src={videoUrl} />
              </ResponsiveEmbed>
              {editMode
                ? <input
                    type="text"
                    id={VIDEO_URL_INPUT_ID}
                    className={`editable-input article__heading-ctrl ${VIDEO_URL_INPUT_ID}`}
                    value={videoUrl}
                    onChange={(e: ChangeEvent<HTMLInputElement>)=>{
                      const newVideoUrl: string = e.target.value;
                      onVideoUrlChange(newVideoUrl);
                    }}
                  />
                : ""
              }
            </div>
            {editMode
              ? <ol>
                  <li>
                    Insert the youtube video embed URL into the box above. Make sure the URL is an
                    absolute URL. Follow <a href={EMBED_URL_EXAMPLE} target="_blank">these </a> 
                    instructions if you don't know how to get the embed URL.
                  </li>
                  <br/>
                  <li>
                    Click anywhere outside the box for changes to take effect. Note that this does 
                    not save your changes.
                  </li>
                  <br/>
                  <li>
                    When you are done. Click the save button (floppy disk icon) at the top of the 
                    screen.
                  </li>
                </ol>
              : ''
            }
          </Col>
        </Row>
        <Row>
          {editMode 
            ? <Modal 
                id={MODAL_ID}
                show={showModal}
                onShow={() => {
                  if (typeof $ === "function") {
                    const $a = $(`#${MODAL_BODY_ID}`);
                    $a.load(UPLOADER_ADDRESS);
                  }
                }}
                onHide={onHideModal}
                size="xl"
                centered
              >
                <Modal.Header closeButton>
                  <Modal.Title>Upload Image</Modal.Title>
                </Modal.Header>
                <Modal.Body
                  id={MODAL_BODY_ID}
                ></Modal.Body>
                <Modal.Footer>
                  <Button 
                    variant="secondary"
                    onClick={onHideModal}
                  >
                    Close
                  </Button>
                </Modal.Footer>
              </Modal>
            : ''
          }
        </Row>
      </Col>
    </>
  );
}
export default ArticleView;